import * as React from 'react';
import { useHistory } from 'react-router-dom';
import {
  KNOWLEDGE_CATALOG_NAVBAR_DROPDOWN_ITEM,
  PORTAL_NAVBAR_DROPDOWN_ITEM,
  VOICEBOX_NAVBAR_DROPDOWN_ITEM,
} from 'vet-bones/components';

import { useAppDispatch } from 'src/ui/app/hooks';
import {
  NAVBAR_DROPDOWN_KNOWLEDGE_CATALOG_ITEM,
  NAVBAR_DROPDOWN_PORTAL_ITEM,
  NAVBAR_DROPDOWN_VOICEBOX_ITEM,
} from 'src/ui/constants/testIds';
import { startedNewVoiceboxConversation } from 'src/ui/features/ui';
import {
  useConnectionIdxForNavigation,
  useOrgDomain,
} from 'src/ui/hooks/navbar/connection';
import { buildRoute } from 'src/ui/utils/buildRoute';
import { redirectToUrl } from 'src/ui/utils/window';

export const useKnowledgeCatalogNavbarDropdownItem = (maybeConnIdx: string) => {
  const org = useOrgDomain();
  const connectionIdx = useConnectionIdxForNavigation(maybeConnIdx);

  const handleClick = React.useCallback(() => {
    const path = buildRoute(org, connectionIdx, 'knowledge-catalog/');
    redirectToUrl(path);
  }, [connectionIdx, org]);

  return React.useMemo(
    () => ({
      ...KNOWLEDGE_CATALOG_NAVBAR_DROPDOWN_ITEM,
      onClick: handleClick,
      testId: NAVBAR_DROPDOWN_KNOWLEDGE_CATALOG_ITEM,
    }),
    [handleClick]
  );
};

export const usePortalNavbarDropdownItem = (maybeConnIdx: string) => {
  const history = useHistory();
  const org = useOrgDomain();
  const connectionIdx = useConnectionIdxForNavigation(maybeConnIdx);

  const handleClick = React.useCallback(() => {
    const path = buildRoute(org, connectionIdx);
    history.push(path);
  }, [connectionIdx, history, org]);

  return React.useMemo(
    () => ({
      ...PORTAL_NAVBAR_DROPDOWN_ITEM,
      onClick: handleClick,
      testId: NAVBAR_DROPDOWN_PORTAL_ITEM,
    }),
    [handleClick]
  );
};

export const useVoiceboxNavbarDropdownItem = (maybeConnIdx: string) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const org = useOrgDomain();
  const connectionIdx = useConnectionIdxForNavigation(maybeConnIdx);

  const handleClick = React.useCallback(() => {
    dispatch(startedNewVoiceboxConversation());
    const path = buildRoute(org, connectionIdx, 'voicebox/');
    history.push(path);
  }, [connectionIdx, dispatch, history, org]);

  return React.useMemo(
    () => ({
      ...VOICEBOX_NAVBAR_DROPDOWN_ITEM,
      onClick: handleClick,
      testId: NAVBAR_DROPDOWN_VOICEBOX_ITEM,
    }),
    [handleClick]
  );
};
